import ConfigResolver from '../../config/ConfigResolver';
import Http from '../../shared/Http/Http';
import _ from 'lodash';

import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUserAttribute,
  CognitoUser
} from "amazon-cognito-identity-js";
import { sessionExpireLogout } from './userActions';
const { IdentityPoolId, ClientId, UserPoolId, region} = ConfigResolver.config();


export const consts = {
  CREATE_PROJECT_PENDING: 'CREATE_PROJECT_PENDING',
  CREATE_PROJECT_FULFILLED: 'CREATE_PROJECT_FULFILLED',
  CREATE_PROJECT_REJECTED: 'CREATE_PROJECT_REJECTED',
  GET_PROJECTS_LIST_PENDING: 'GET_PROJECTS_LIST_PENDING',
  GET_PROJECTS_LIST_FULFILLED: 'GET_PROJECTS_LIST_FULFILLED',
  GET_PROJECTS_LIST_REJECT: 'GET_PROJECTS_LIST_REJECT',
  DELETE_PROJECT_PENDING: 'DELETE_PROJECT_PENDING',
  DELETE_PROJECT_FULFILLED: 'DELETE_PROJECT_FULFILLED',
  DELETE_PROJECT_REJECT: 'DELETE_PROJECT_REJECT',
  DUBLICATE_PROJECT_PENDING: 'DUBLICATE_PROJECT_PENDING',
  DUBLICATE_PROJECT_FULFILLED: 'DUBLICATE_PROJECT_FULFILLED',
  DUBLICATE_PROJECT_REJECTED: 'DUBLICATE_PROJECT_REJECTED',
  RESET_CREATE_PROJECT: 'RESET_CREATE_PROJECT',
  TOOLKIT_VALIDATION_PENDING: "TOOLKIT_VALIDATION_PENDING",
  TOOLKIT_VALIDATION_FULFILLED: "TOOLKIT_VALIDATION_FULFILLED",
  TOOLKIT_VALIDATION_REJECTED: "TOOLKIT_VALIDATION_REJECTED",
  RESET_TOOLKIT_VALIDATION: "RESET_TOOLKIT_VALIDATION",
  RESET_DELETE_PROJECT: "RESET_DELETE_PROJECT",
  SEND_MESSAGE_PENDING: "SEND_MESSAGE_PENDING",
  SEND_MESSAGE_FULFILLED: "SEND_MESSAGE_FULFILLED",
  SEND_MESSAGE_REJECTED: "SEND_MESSAGE_REJECTED"
}

const refreshAccessToken = (options, dispatch) => {
  return new Promise((resolve, reject) => {
    const poolData = { ClientId, UserPoolId };
    var userPool = new CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    cognitoUser.getSession((err, session) => {
      if (err) {
        sessionExpireLogout(dispatch);
        localStorage.removeItem('userToken');
        reject(err);
      } else {
        resolve(session.getIdToken().getJwtToken());
      }
    });
  });
};

export function createProject(data){
  return async (dispatch, currentState) => {
    dispatch({
        type: consts.CREATE_PROJECT_PENDING,
    });
    data.provider = 'ipg';
    const url = '/project/create';
    let token = await refreshAccessToken(currentState().options, dispatch);
    Http.post(url, data, currentState, false, token)
    .then((response) => {
      dispatch({
        type: consts.CREATE_PROJECT_FULFILLED,
        data: response.data
      });
    })
    .catch((error) => {
      console.log(error);
      dispatch({
          type: consts.CREATE_PROJECT_REJECTED,
          error: error
      });
    });
  }
}

export function dublicateProject(data){
  return async (dispatch, currentState) => {
    dispatch({
        type: consts.DUBLICATE_PROJECT_PENDING,
    });
    data.provider = 'ipg';
    const url = '/project/duplicate';
    let token = await refreshAccessToken(currentState().options, dispatch);
    Http.post(url, data, currentState, false, token)
    .then((response) => {
      dispatch({
        type: consts.DUBLICATE_PROJECT_FULFILLED,
        data: response.data
      });
    })
    .catch((error) => {
      console.log(error);
      dispatch({
          type: consts.DUBLICATE_PROJECT_REJECTED,
          error: error
      });
    });
  }
}

export function toolkitValidation(data){
  return async (dispatch, currentState) => {
    dispatch({
        type: consts.TOOLKIT_VALIDATION_PENDING,
    });
    data[0].provider = 'ipg'
    const url = '/toolkits/validation';
    let token = await refreshAccessToken(currentState().options, dispatch);
    Http.post(url, data, currentState, false, token)
    .then((response) => {
      dispatch({
        type: consts.TOOLKIT_VALIDATION_FULFILLED,
        data: response.data
      });
    })
    .catch((error) => {
      console.log(error);
      dispatch({
          type: consts.TOOLKIT_VALIDATION_REJECTED,
          error: error
      });
    });
  }
}

export function resetToolkitValidation() {
  return (dispatch) => {
    dispatch({type: consts.RESET_TOOLKIT_VALIDATION});
  }
}

export function getProjectsList(){
  return async (dispatch, currentState) => {
    dispatch({ type: consts.GET_PROJECTS_LIST_PENDING });
    const url = '/project/get?provider=ipg';
    let token = await refreshAccessToken(currentState().options, dispatch);
    Http.get(url, currentState, false, token)
      .then(response => {
        dispatch({ type: consts.GET_PROJECTS_LIST_FULFILLED, data: response.data });
      })
      .catch((error) => {
          console.log(error);
          dispatch({ type: consts.GET_PROJECTS_LIST_REJECT, error });
      });
  };
}

export function deleteProject(data){
  return async (dispatch, currentState) => {
    dispatch({
        type: consts.DELETE_PROJECT_PENDING,
    });

    data.provider = 'ipg'
    const url = '/project/delete';
    let token = await refreshAccessToken(currentState().options, dispatch);
    Http.delete(url, data, currentState, false, token)
    .then((response) => {
      dispatch({
        type: consts.DELETE_PROJECT_FULFILLED,
        data: response.data
      });
    })
    .catch((error) => {
      console.log(error);
      dispatch({
          type: consts.DELETE_PROJECT_REJECT,
          error: error
      });
    });
  }
}

export function resetCreateProject() {
  return (dispatch) => {
    dispatch({type: consts.RESET_CREATE_PROJECT});
  }
}

export function resetDeleteProject() {
  return (dispatch) => {
    dispatch({type: consts.RESET_DELETE_PROJECT});
  }
}

export function sendMessage(data){
  return async (dispatch, currentState) => {
    dispatch({
        type: consts.SEND_MESSAGE_PENDING,
    });

    const url = '/send/contacts';
    let token = await refreshAccessToken(currentState().options, dispatch);
    Http.post(url, data, currentState, false, null)
    .then((response) => {
      dispatch({
        type: consts.SEND_MESSAGE_FULFILLED,
        data: response.data
      });
    })
    .catch((error) => {
      console.log(error);
      dispatch({
          type: consts.SEND_MESSAGE_REJECTED,
          error: error
      });
    });
  }
}








// WEBPACK FOOTER //
// ./src/store/actions/ToolkitActions.js